/**
 * Shared column templates for the workflow editors, extracted from
 * `SettingsWorkflowsPanel.tsx` so the data rows + the "select all on page"
 * header rows line up vertically even when one badge label is much longer
 * than another ("Waiting on Customer" vs "Open").
 *
 *   checkbox │ badge (10rem) │ name (1fr) │ colour (3rem) │ category (7rem) │ save (4rem) │ delete (2rem)
 */
export const STATUS_GRID = "1rem 10rem 1fr 3rem 7rem 4rem 2rem";
/** Same column system as STATUS_GRID, minus the category cell. */
export const PRIORITY_GRID = "1rem 10rem 1fr 3rem 4rem 2rem";
